import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { FycStatus } from "JS/Models/FycStatus";
import { appConstants } from "JS/Helpers/Constants";
import { AxiosResponse } from "axios";

export class FycStatusService extends BaseService {
    async getFycStatus(
        sendCall: boolean,
        defaultFycStatusInfo: FycStatus | undefined,
    ) {
        if (sendCall || !defaultFycStatusInfo) {
            return await this.ngCall<FycStatus>(
                "get",
                appConstants.ngEndpoints.getFycStatus(config.user.memberId),
            );
        } else {
            return new Promise<AxiosResponse<FycStatus>>((res) => {
                res({
                    data: defaultFycStatusInfo as FycStatus,
                    status: 200,
                    statusText: "OK",
                    headers: {},
                    config: { headers: {} as any },
                });
            });
        }
    }
}
